<span id="message-text"> Il messaggio è stato inviato con successo. </span>